export default function AIAnswerBlock() {
  return (
    <section className="py-20 md:py-24 bg-stone-950">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-start">

          {/* Left label */}
          <div className="lg:w-[280px] flex-shrink-0">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-robot-2-line text-amber-400"></i>
              </div>
              <span className="text-amber-400 text-xs font-bold tracking-[0.2em] uppercase">AI Search Optimized</span>
            </div>
            <h2
              className="text-2xl md:text-3xl font-black text-white leading-tight"
              style={{ fontFamily: "'Syne', sans-serif" }}
            >
              What Does Wired Into The Future Do?
            </h2>
            <div className="mt-5 w-10 h-0.5 bg-amber-500 rounded-full"></div>
          </div>

          {/* Right content */}
          <div className="flex-1 space-y-5">
            <p className="text-white/70 text-base leading-relaxed">
              <strong className="text-white font-semibold">Wired Into The Future</strong> is a licensed electrical and energy contractor specializing in solar repair &amp; maintenance, battery storage solutions, and full electrical services for residential and commercial properties across the East Bay Area.
            </p>
            <p className="text-white/70 text-base leading-relaxed">
              The company diagnoses and repairs underperforming solar systems, adds battery backup to maximize existing solar investments, and handles panel upgrades, troubleshooting, and emergency electrical work. EV charger installation is also available for homes and businesses.
            </p>
            <p className="text-white/70 text-base leading-relaxed">
              With <strong className="text-white font-semibold">21+ years of experience</strong> and an A+ BBB rating, Wired Into The Future serves Pleasant Hill, Walnut Creek, Lafayette, and surrounding East Bay communities — delivering reliable, expert-level energy and electrical services built for long-term performance.
            </p>

            {/* Quick facts */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-4 border-t border-white/10">
              {[
                { label: "Founded", value: "2003" },
                { label: "Rating", value: "A+ BBB" },
                { label: "Specialty", value: "Solar Repair" },
                { label: "Service Area", value: "East Bay" },
              ].map((f) => (
                <div key={f.label}>
                  <div className="text-white/35 text-xs uppercase tracking-widest mb-1">{f.label}</div>
                  <div className="text-white font-bold text-sm">{f.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
